import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { dispatch } from '@ngneat/effects';

import { NotificationCardType } from '../../models/notification-card';
import {
  dismissContentCard,
  handleContentCardClicked,
} from '../../repositories/content-cards/content-cards.actions';
import { getContentCardById } from '../../repositories/content-cards/content-cards.repository';

@Component({
  selector: 'app-notification-card',
  templateUrl: './notification-card.component.html',
  styleUrls: ['./notification-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class NotificationCardComponent {
  @Input() id: null | string = null;
  @Input() title = '';
  @Input() description = '';
  @Input() linkText = '';
  @Input() linkUrl = '';
  @Input() imageUrl = '';
  @Input() cardType: NotificationCardType = 'feature';

  handleClick() {
    if (this.id !== null) {
      dispatch(handleContentCardClicked({ id: this.id }));
    }

    window.open(this.linkUrl, '_blank');
  }

  dismiss() {
    if (typeof this.id === 'string') {
      const card = getContentCardById(this.id);
      if (card !== null) {
        dispatch(dismissContentCard({ card }));
      }
    }
  }
}
